import { config } from '@shared/config';

/** Modul-weiter Token-Provider — wird beim Auth-Setup registriert. */
let tokenProvider: (() => Promise<string | null>) | null = null;

/**
 * Registriert die getToken-Funktion von Clerk für automatische Authentifizierung.
 *
 * @param getToken - Clerk getToken Funktion aus useAuth()
 */
export function setTokenProvider(getToken: () => Promise<string | null>) {
  tokenProvider = getToken;
}

/**
 * Gibt den aktuellen Auth-Token zurück (für multipart-Uploads etc.).
 *
 * @returns JWT-Token oder null
 */
export async function getAuthToken(): Promise<string | null> {
  if (!tokenProvider) return null;
  return tokenProvider();
}

/**
 * Basis-Fetch-Wrapper für authentifizierte API-Aufrufe.
 * Nutzt den registrierten Token-Provider um automatisch den Clerk JWT-Token mitzusenden.
 *
 * @param path - API-Pfad relativ zur Base-URL (z.B. '/events')
 * @param options - Optionale RequestInit-Konfiguration
 * @returns Geparste JSON-Antwort als generischer Typ T
 * @throws Error bei HTTP-Fehlerantworten
 */
export async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options?.headers as Record<string, string>),
  };

  if (tokenProvider) {
    const token = await tokenProvider();
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  const res = await fetch(`${config.apiUrl}${path}`, {
    ...options,
    headers,
  });
  if (!res.ok) {
    let message = `API Error: ${res.status} ${res.statusText}`;
    try {
      const body = await res.json();
      if (body && typeof body === 'object' && 'error' in body) {
        message = String((body as { error: string }).error);
      }
    } catch {
      /* Body not JSON — use default message */
    }
    throw new Error(message);
  }
  return res.json() as Promise<T>;
}
